module.exports = __webpack_public_path__ + "static/media/registration.3d895987.jpg";